import { BaseSelectorOption } from "@/types";
import { Component } from "react";
import { SingleSelector } from "./SingleSelector";

export class AddressSelector extends Component<any, any> {
  static defaultProps = {
    label: ""
  };

  constructor(props: any) {
    super(props);

    this.state = {};
  }

  render() {
    return <SingleSelector<BaseSelectorOption> {...this.props} hasNewItem={false} />;
  }
}
